<nb-card class="control-report-dialog">
  <nb-card-header class="header">
    <img src="assets/images/risk-report.jpg" alt="RISK" class="risk-indicator-image" />
    <div class="title">{{ "asset_form_drawer.compliance.control_report.title" | translate }}</div>
    <span class="close-btn" (click)="cancel()">
      <i class="fa-light fa-x"></i>
    </span>
  </nb-card-header>
  <nb-card-body class="body">
    @if (form) {
    <form [formGroup]="form" class="form-group">
      <!-- Libellé rapport -->
      <div class="form-field" [style.background-color]="getFieldBackgroundColor('libelle_rapport')">
        <label for="libelle_rapport">{{ "asset_form_drawer.compliance.control_report.libelle_rapport" | translate }}</label>
        @if (isEditable  && form) {
          <input
            nbInput
            type="text"
            formControlName="libelle_rapport"
            (input)="markUserInteraction()"
            fullWidth
            placeholder="-"
          />
        } @else {
          <div class="field-value">
            {{ form?.get('libelle_rapport')?.value || '-' }}
          </div>
        }
      </div>

      <!-- Date -->
      <div class="form-field pb-2" [style.background-color]="getFieldBackgroundColor('date_controle')">
        <label for="date_controle">{{ "asset_form_drawer.compliance.control_report.date" | translate }}</label>
        @if (isEditable && form) {
          <div class="datepicker-field">
            <input
              nbInput
              class="date-input"
              [nbDatepicker]="dateControlePicker"
              [value]="getFormattedDate('date_controle')"
              (dateChange)="onDateChange($event, 'date_controle')"
              [disabled]="isReportFormDisabled()"
              placeholder="-"
              (click)="!isReportFormDisabled() && !dateControlePicker.isShown && dateControlePicker.show()"
            />
            <button
              type="button"
              class="datepicker-toggle"
              [disabled]="isReportFormDisabled()"
              (click)="$event.preventDefault(); $event.stopPropagation(); !isReportFormDisabled() && (dateControlePicker.isShown ? dateControlePicker.hide() : dateControlePicker.show())"
            >
              <i class="fa-light fa-calendar"></i>
            </button>
          </div>
          <nb-datepicker
            #dateControlePicker
            [date]="getDateValue(form.get('date_controle')?.value)"
            [visibleDate]="getDateValue(form.get('date_controle')?.value) || defaultDatepickerDate()"
          ></nb-datepicker>
        } @else {
          <div class="field-value">
            {{ getFormattedDate('date_controle') || '-' }}
          </div>
        }
      </div>

      <!-- URL -->
      <div class="form-field">
        <label for="url">{{ "asset_form_drawer.compliance.control_report.url" | translate }}</label>
        @if (isEditable && form) {
          <div class="url-input-container">
          <input
            nbInput
            type="text"
            formControlName="url"
            fullWidth
            maxlength="200"
            placeholder="-"
            [title]="form.get('url')?.value || ''"
            (blur)="onUrlBlur($event)"
            (focus)="onUrlFocus($event)"
          />
            @if (form.get('url')?.value && !isReportFormDisabled()) {
              <button
                type="button"
                class="url-link-icon"
                (click)="openUrl(form.get('url')?.value, $event)"
                [title]="form.get('url')?.value"
              >
                <fa-icon icon="up-right-from-square"></fa-icon>
              </button>
            }
          </div>
        } @else {
          <div class="field-value">
            @if (form?.get('url')?.value) {
              <a [href]="form.get('url')?.value" target="_blank" class="url-link" [title]="form.get('url')?.value">
                {{ getFormattedUrl(form.get('url')?.value) }}
              </a>
            } @else {
              -
            }
          </div>
        }
      </div>

      <!-- Équipement(s) lié(s) -->
      <div class="form-field">
        <label for="equipements_lies" class="equipement-label">{{ "asset_form_drawer.compliance.control_report.equipements_lies" | translate }}</label>
        @if (isEditable && form) {
          <div class="equipment-input-container">
            <input
              nbInput
              type="text"
              [value]="form?.get('equipements_lies')?.value || '-'"
              readonly
              [disabled]="isReportFormDisabled()"
              fullWidth
              (click)="!isReportFormDisabled() && openLinkedEquipmentDialog()"
              [style.cursor]="isReportFormDisabled() ? 'not-allowed' : 'pointer'"
              [style.opacity]="isReportFormDisabled() ? '0.6' : '1'"
            />
            <span 
              class="right-chevron" 
              (click)="!isReportFormDisabled() && openLinkedEquipmentDialog()"
              [style.cursor]="isReportFormDisabled() ? 'not-allowed' : 'pointer'"
              [style.opacity]="isReportFormDisabled() ? '0.6' : '1'"
            >
              <i class="far fa-chevron-right fal"></i>
            </span>
          </div>
        } @else {
          <div class="field-value" (click)="openLinkedEquipmentDialog()" style="cursor: pointer;">
            {{ form?.get('equipements_lies')?.value || '-' }}
          </div>
        }
      </div>

      <!-- Commentaire -->
      <div class="form-field">
        <label for="commentaire">{{ "asset_form_drawer.compliance.control_report.commentaire" | translate }}</label>
        @if (isEditable && form) {
          <textarea
            nbInput
            formControlName="commentaire"
            (input)="markUserInteraction()"
            fullWidth
            rows="3"
            placeholder="-"
          ></textarea>
        } @else {
          <div class="field-value">
            {{ form?.get('commentaire')?.value || '-' }}
          </div>
        }
      </div>

      <!-- Reserves List -->
      @for (reserve of reserves; track $index) {
      <div class="reserve-header" [attr.data-reserve-index]="$index" [attr.data-reserve-id]="reserve.id">
        <label style="color: #dc3545; font-weight: 600; flex: 1; text-align: center">
          {{ "asset_form_drawer.compliance.reserve_number" | translate: { number: $index + 1 } }}
        </label>
        <i 
          class="fa-light fa-trash-can delete-icon" 
          [style.pointer-events]="isReserveFormDisabled() ? 'none' : 'auto'"
          [style.opacity]="isReserveFormDisabled() ? '0.5' : '1'"
          (click)="!isReserveFormDisabled() && deleteReserve($index)">
        </i>
      </div>

      <!-- Libellé réserve -->
      <div class="form-field" [style.background-color]="getReserveFieldBackgroundColor($index, 'libelle')">
        <label>{{ "asset_form_drawer.compliance.reserve_label" | translate }}</label>
        <input
          nbInput
          type="text"
          [value]="reserve.libelle"
          [disabled]="isReserveFormDisabled()"
          (input)="onReserveLabelChange($index, $event)"
          fullWidth
          required
          maxlength="200"
          placeholder="-"
        />
      </div>

      <!-- Stade (Status) -->
      <div class="form-field" [style.background-color]="getReserveFieldBackgroundColor($index, 'stade')">
        <label>{{ "asset_form_drawer.compliance.reserve_status" | translate }}</label>
        <nb-select
          [selected]="reserve.stade || ''"
          [disabled]="isReserveFormDisabled()"
          (selectedChange)="onReserveStadeChange($index, $event)"
          fullWidth
          required
        >
          <nb-option value="">-</nb-option>
          <nb-option value="active">{{ "site_control_reports.status_active" | translate }}</nb-option>
          <nb-option value="closed">{{ "site_control_reports.status_closed" | translate }}</nb-option>
          <nb-option value="abandoned">{{ "site_control_reports.status_abandoned" | translate }}</nb-option>
        </nb-select>
      </div>

      <!-- Criticité (Criticality) -->
      <div class="form-field">
        <label>{{ "asset_form_drawer.compliance.reserve_criticality" | translate }}</label>
        <nb-select
          [selected]="reserve.criticite || ''"
          [disabled]="isReserveFormDisabled()"
          (selectedChange)="onReserveCriticiteChange($index, $event)"
          fullWidth
        >
          <nb-option value="">-</nb-option>
          <nb-option value="critical">{{ "asset_form_drawer.options.criticality_critical" | translate }}</nb-option>
          <nb-option value="non_critical">{{ "asset_form_drawer.options.criticality_non_critical" | translate }}</nb-option>
        </nb-select>
      </div>

      <!-- Responsable levée de réserve -->
      <div class="form-field">
        <label>{{ "asset_form_drawer.compliance.reserve_responsible" | translate }}</label>
        <input
          nbInput
          type="text"
          [value]="reserve.responsable"
          [disabled]="isReserveFormDisabled()"
          (input)="onReserveResponsableChange($index, $event)"
          fullWidth
          maxlength="50"
          placeholder="-"
        />
      </div>

      <!-- Date clôture -->
      <div class="form-field pb-2">
        <label>{{ "asset_form_drawer.compliance.reserve_closing_date" | translate }}</label>
        <div class="datepicker-field">
          <input
            nbInput
            class="date-input"
            [nbDatepicker]="reserveClotureDate"
            [value]="getFormattedReserveDate(reserve.date_cloture)"
            [disabled]="isReserveFormDisabled()"
            (dateChange)="onReserveClotureDateChange($event, $index)"
            placeholder="-"
            (click)="!isReserveFormDisabled() && !reserveClotureDate.isShown && reserveClotureDate.show()"
          />
          <button
            type="button"
            class="datepicker-toggle"
            [disabled]="isReserveFormDisabled()"
            (click)="$event.preventDefault(); $event.stopPropagation(); !isReserveFormDisabled() && (reserveClotureDate.isShown ? reserveClotureDate.hide() : reserveClotureDate.show())"
          >
            <i class="fa-light fa-calendar"></i>
          </button>
        </div>
        <nb-datepicker
          #reserveClotureDate
          [date]="getReserveDateValue(reserve.date_cloture)"
          [visibleDate]="getReserveDateValue(reserve.date_cloture) || defaultDatepickerDate()"
        ></nb-datepicker>
      </div>
      }

      <!-- Add Reserve Button -->
      <nb-accordion>
        <nb-accordion-item expanded="false" disabled="true" class="accordion-item-as-button" [style.pointer-events]="isReserveFormDisabled() ? 'none' : 'auto'">
          <nb-accordion-item-header (click)="!isReserveFormDisabled() && addReserve()" [style.opacity]="isReserveFormDisabled() ? '0.5' : '1'">
            <span>
              (+)
              {{ "asset_form_drawer.compliance.control_report.add_reserve" | translate }}
            </span>
          </nb-accordion-item-header>
        </nb-accordion-item>
      </nb-accordion>
    </form>
    }
  </nb-card-body>
  
  @if (isEditable && canSave() && hasChanges()) {
  <div class="sticky-save-container">
    <div class="sticky-save-button" [class.has-reserves]="hasReserveChanges()">
      <button nbButton type="button" (click)="save()" status="primary">
        {{ "site_control_reports.save" | translate }}
      </button>
    </div>
  </div>
  }
</nb-card>
